import React from 'react'
import styled from 'styled-components'


const Container = styled.nav`
  height: 107px;
  width: 100%;
  display: grid;
  justify-content: space-between;
  align-items: center;
  background-color: #13294b;

  border-top: 7px solid #FF552E;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 30px auto;

  @media (max-width: 420px) {
    grid-template-rows: 30px 55px;
    height: 100px;
  }

`
const HeaderTop = styled.div`
  height: 30px;
  box-sizing: border-box;
  grid-column-start: 1;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 2;
  background-color: #eff0f4;
  padding: 3px 8px 3px 30px;

  @media (max-width: 420px) {
    padding: 2px 10px 2px 10px;
  }
`

const HeaderCenter = styled.div`
  justify-self: center;
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 10px;
`

const HeaderLeft = styled.div`
  box-sizing: border-box;
  padding-left: 30px;
  line-height: 1.05;
  
  @media (max-width: 768px) {
    padding-left: 30px;
    padding-top: 1.5px;
    width: 180px;
  } 
  @media (max-width: 420px) {
    padding-left: 11.5px;
    width: 160px;
  }
`

const HeaderRight = styled.div`
  justify-self: right;
  box-sizing: border-box;
  padding-right: 30px;
  
  @media (max-width: 420px) {
    padding-right: 10px;
  }
`

const OrganizationText = styled.a`
  font-weight: 700;
  color: #13294b;
  font-size: 12px;
  letter-spacing: 1.75px;
  text-decoration: none;
  :focus { 
  	outline: 3px solid #FF9900;
  }
  
  @media (max-width: 420px) {
    letter-spacing: .5px;   
  }
  
`

const Header = ({leftContent, centerContent, rightContent}) => {
  return (
    <Container role="navigation">
	  <HeaderTop><OrganizationText href="https://illinois.edu/" target="_blank">UNIVERSITY OF ILLINOIS URBANA-CHAMPAIGN</OrganizationText></HeaderTop>
	  <HeaderLeft>{leftContent}</HeaderLeft>
	  <HeaderCenter>{centerContent}</HeaderCenter>
	  <HeaderRight>{rightContent}</HeaderRight>
    </Container>
  )
}

export default Header
